import clsx from "clsx";

import WarningBrowser from "@Components/Icons/WarningBrowser.svg";

import type { IContentContainer } from "../common/ContentContainer";
import ContentContainer from "../common/ContentContainer";

import * as css from "./BrowserSupport.module.css";

export interface IBrowserNotSupported {
    title: string;
    description: string;
    contentContainers?: IContentContainer;
}

export const BrowserNotSupported = (props: IBrowserNotSupported) => (
    <div className={clsx(css.browserSupport, "container")}>
        <img src={WarningBrowser} />
        <h1 className={css.title}>{props.title}</h1>
        <p dangerouslySetInnerHTML={{ __html: props.description }} />
        <ContentContainer {...props.contentContainers} />
    </div>
);
